/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface UpdateAccountCrmId$Request {
    accountId: number;
    body?: string;
}

export interface UpdateAccountCrmId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountCrmIdRequest = createAction<PayloadData<void, UpdateAccountCrmId$Request>>('UPDATE_ACCOUNT_CRM_ID__UPDATE_ACCOUNT_CRM_ID__REQUEST');
export const updateAccountCrmIdSuccess = createAction<PayloadData<void, UpdateAccountCrmId$Request>>('UPDATE_ACCOUNT_CRM_ID__UPDATE_ACCOUNT_CRM_ID__SUCCESS');
export const updateAccountCrmIdFailure = createAction<PayloadData<Error, UpdateAccountCrmId$Request, true>>('UPDATE_ACCOUNT_CRM_ID__UPDATE_ACCOUNT_CRM_ID__FAILURE');

export const updateAccountCrmIdActions = [
    updateAccountCrmIdRequest,
    updateAccountCrmIdSuccess,
    updateAccountCrmIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} [meta.body]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountCrmId = (meta: UpdateAccountCrmId$Request, config?: UpdateAccountCrmId$Config) => {
    return {
        CALL_API: {
            types: updateAccountCrmIdActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/crm-ids`,
            TRANSPORT_REQUEST_BODY: meta.body,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

